import ReactDOM from "react-dom/client";
import { Modal, Button, Row, Col } from "react-bootstrap";
import logo from "../assets/icons/hem-logo.png";

export const openConfirmDialog = (
    title: string,
    confirmButtonText: string,
    cancleButtonText: string,
    onConfirm: () => void,
    iconName?: string,
) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);
    const root = ReactDOM.createRoot(modalContainer);

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(modalContainer);
    };

    const onConfirmClick = () => {
        closeModal();
        onConfirm();
    };

    root.render(
        <Modal show={true}
            onHide={closeModal}
            centered
        >
            <Modal.Header className="py-3 px-4 border-bottom-0 d-flex">
                <div style={{ marginLeft: 'auto' }} onClick={closeModal}>
                    <i className="fas fa-times all-small-icon"></i>
                </div>
            </Modal.Header>

            <Modal.Body >
                <div className="text-center">
                    <img src={logo} alt="Logo" className="custom-logo" />
                </div>

                <h4 className="custom-header-title">{title}</h4>

                <Row className="mt-5">
                    <Col xs={6} className="text-center">
                        <Button type="submit" className="custom-button w-100" onClick={onConfirmClick}>
                            {confirmButtonText}
                        </Button>
                    </Col>
                    <Col xs={6} className="text-center" onClick={closeModal}>
                        <Button className="custom-outline-button w-100">
                            {cancleButtonText}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
